export const PROVIDER_ORIGIN_OPTIONS = [
  { value: 'my_providers', label: 'Meus prestadores' },
  { value: 'imported_from_refera', label: 'Importados da Refera' },
]

export const LIMIT = 5
export const SAAS_LIMIT = 50

export const getProviderLimit = agencyContractType => {
  return agencyContractType === 'SAAS' ? SAAS_LIMIT : LIMIT
}
